























































































































import { Component, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import SuperAdminSvc from "@/services/SuperAdmin";
import superAdminStore from "@/store/modules/SuperAdminStore";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import {
  auditEntityLabel,
  auditFieldLabel,
  auditFieldValue
} from "@/utils/auditFieldLabel";

@Component
export default class SuperAdminAuditPage extends Vue {
  rptData: any = null;
  loading = false;
  pendingReload = false;
  options: any = null;
  expanded: any[] = [];

  meta: { auditable_types: string[]; events: string[] } = {
    auditable_types: [],
    events: []
  };

  fAuditableType: string | null = null;
  fEvent: string | null = null;
  fSearch = "";
  fTglStart = "";
  fTglEnd = "";

  headers = [
    { text: "Waktu", value: "created_at" },
    { text: "User", value: "user", sortable: false },
    { text: "Event", value: "event" },
    { text: "Entitas", value: "auditable_type" },
    { text: "ID", value: "auditable_id", sortable: false },
    { text: "IP", value: "ip_address", sortable: false },
    { text: "", value: "data-table-expand" }
  ];

  get exporting(): boolean {
    return superAdminStore.exporting;
  }

  get canExport(): boolean {
    return userModule.hasPrivilege("audit_trail", "report");
  }

  get entityItems() {
    return this.meta.auditable_types.map(t => ({
      text: auditEntityLabel(t),
      value: t
    }));
  }

  get listItems() {
    return this.rptData
      ? this.rptData.data.map((item: any) => ({
          ...item,
          created_at: item.created_at
            ? moment(item.created_at).format("DD-MM-YYYY HH:mm:ss")
            : "-"
        }))
      : [];
  }

  get listItemsTotal(): number {
    return this.rptData ? this.rptData.total : 0;
  }

  get filterParams() {
    return {
      auditable_type: this.fAuditableType || undefined,
      event: this.fEvent || undefined,
      search: this.fSearch || undefined,
      tgl_start: this.fTglStart || undefined,
      tgl_end: this.fTglEnd || undefined
    };
  }

  mounted() {
    this.loadMeta();
  }

  async loadMeta() {
    try {
      const res = await SuperAdminSvc.auditMeta();
      this.meta = res.data;
    } catch (e) {
      /* handled by service */
    }
  }

  @Watch("options", { deep: true })
  onOptionsChanged() {
    this.getData();
  }

  getData() {
    if (!this.options) return;
    if (this.loading) {
      this.pendingReload = true;
      return;
    }

    const { page, itemsPerPage, sortBy, sortDesc } = this.options;
    const params = {
      page,
      per_page: itemsPerPage,
      sort_by: sortBy && sortBy.length ? sortBy[0] : "created_at",
      sort_desc: sortDesc && sortDesc.length ? sortDesc[0] : true,
      ...this.filterParams
    };

    this.loading = true;
    SuperAdminSvc.auditList(params)
      .then(res => {
        this.rptData = res.data;
      })
      .finally(() => {
        this.loading = false;
        if (this.pendingReload) {
          this.pendingReload = false;
          this.getData();
        }
      });
  }

  applyFilters() {
    if (this.options && this.options.page !== 1) {
      this.options.page = 1; // memicu watch → getData
    } else {
      this.getData();
    }
  }

  resetFilters() {
    this.fAuditableType = null;
    this.fEvent = null;
    this.fSearch = "";
    this.fTglStart = "";
    this.fTglEnd = "";
    this.applyFilters();
  }

  eventColor(event: string): string {
    const map: Record<string, string> = {
      created: "green",
      updated: "blue",
      deleted: "red",
      restored: "orange"
    };
    return map[event] || "grey";
  }

  entityLabel(type: string): string {
    return auditEntityLabel(type);
  }

  fieldLabel(key: string): string {
    return auditFieldLabel(key);
  }

  fmtVal(v: unknown, key = ""): string {
    return auditFieldValue(key, v);
  }

  async doExport(format: string) {
    try {
      await superAdminStore.exportAudit({ format, params: this.filterParams });
      appModule.NoticeDelay("Ekspor audit sedang diunduh");
    } catch (e) {
      /* handled */
    }
  }
}
